import * as moment from 'moment';
import 'moment/locale/da';
import Moment = moment.Moment;
import {PriceRobotFilter} from "./price-robot-filter";
import {BasketLine} from "./basket-line";

export class PriceRobotReport {

    id?: number;
    name?: string;
    conditions_data?: PriceRobotFilter;
    conditions_query?: string;
    is_active?: boolean
    users?: any;

    static _JSONProps: string[] = [
        'id',
        'name',
        'conditions_query',
        'is_active'
    ];

    constructor(initializer?: PriceRobotReportInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: PriceRobotReportInterface | string): PriceRobotReport {
        if (json === null) {
            return new PriceRobotReport();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, PriceRobotReport.reviver);
        } else {
            let task = Object.create(PriceRobotReport.prototype);

            let extra = {
                conditions_data: null,
                users: []
            };

            Object.keys(json).forEach((key, index) => {
                if (PriceRobotReport._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'conditions_data') {
                   extra.conditions_data = json[key];
                }

                if (key === 'users') {
                   extra.users = json[key];
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? PriceRobotReport.fromJSON(value) : value;
    }
}

export interface PriceRobotReportInterface extends PriceRobotReport {
}
